module.exports = __webpack_public_path__ + "static/downloable/guia-solicitud-de-aviso-de-fallecimiento.83ee2c4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/guias/guia-solicitud-de-aviso-de-fallecimiento.pdf
// module id = fsJh
// module chunks = 1